import { useQuery } from "@tanstack/react-query";
import { searchNotes } from "@/notes/api/notes";

export const useSearchNotes = (query: string) => {
	return useQuery({
		queryKey: ["search", query],
		queryFn: () => searchNotes(query),
		enabled: query.trim().length > 0,
	});
};
